import { createCrudApi } from 'src/shared/api/crudApi';
import { API_PREFIX } from 'src/shared/constants';
import type { Expense, ExpenseListParams, ExpensePayload } from './types';

const base = `${API_PREFIX}/expenses`;

/**
 * Plain CRUD, unlike payments: an expense is the salon's own note to itself, so
 * it is created, edited and retired like any other record.
 *
 * The update payload is `Partial<ExpensePayload>` because every `PUT` in this
 * API applies only the fields it receives.
 */
export const expensesApi = createCrudApi<
  Expense,
  ExpenseListParams,
  ExpensePayload,
  Partial<ExpensePayload>
>(base);
